import { get, set } from 'lodash';

/**
 * Build an object with the given keys & initialisation value
 * @param  {String[]} keys - list of properties. Keys can be
 * @param  {Number}   [defaultValue=0] - value to initialise properties with
 * @return {Object}   an object with all the given properties initialised
 */
const buildObjectFromKeys = (keys, defaultValue = 0) =>
    keys && keys.reduce((accu, key) => set({ ...accu }, key, defaultValue), {});

/**
 * Sums 2 objects' properties
 * If a property is not defined in one of the objects, 0 is used instead
 * If a property is null, then it returns the other object's value
 * @param  {Object}   obj1 - first object to sum
 * @param  {Object}   obj2 - second object to sum
 * @param  {String[]} keys - list of properties to sum on the objects.
 *                           Keys can be paths supported by lodash get method
 * @return {Object}   a new object with the summed properties
 */
const sumObjectsProperties = (obj1, obj2, keys) =>
    keys.reduce((accu, key) => {
        const value1 = get(obj1, key, 0);
        const value2 = get(obj2, key, 0);

        let result = value1;
        if (result === null) result = value2;
        else if (value2 !== null) result += value2;

        return set({ ...accu }, key, result);
    }, {});

export { buildObjectFromKeys, sumObjectsProperties };
